import { faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FilterTab, { FilterTabItem } from 'components/common/FilterTab';
import SearchBox from 'components/common/SearchBox';
import { Proceso } from 'data/project-management/procesos';
import { useAdvanceTableContext } from 'providers/AdvanceTableProvider';
import { ChangeEvent, useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';

interface ProcesosTopSectionInterface {
  activeView: 'list' | 'board' | 'card';
}

const PagosGeneralesTopSection = ({ activeView }: ProcesosTopSectionInterface) => {
  const { setGlobalFilter, getPrePaginationRowModel, getColumn } =
    useAdvanceTableContext<Proceso>();

  const handleFilterItemClick = (columnId: string, value: string) => {
    const column = getColumn(columnId);
    column?.setFilterValue(value === 'TODOS' ? '' : value);
  };

  // Compute counts for all labels once to avoid redundant filtering
  const counts = useMemo(() => {
    const rows = getPrePaginationRowModel().rows;
    const countMap: { [key: string]: number } = {
      TODOS: rows.length,
      FAM: 0,
      EA: 0,
      IS: 0,
      ISV: 0,
      LA: 0,
      MSJ: 0,
      ZCC: 0,
      '': 0, // For SIN ASIGNAR
    };

    rows.forEach(({ original: { MIEM } }) => {
      // Increment count for the MIEM value or '' if MIEM is null/undefined
      const key = MIEM || '';
      countMap[key] = (countMap[key] || 0) + 1;
    });

    return countMap;
  }, [getPrePaginationRowModel().rows]); // Depend on rows directly for stability

  const tabItems: FilterTabItem[] = useMemo(() => {
    return [
      {
        label: 'TODOS',
        value: 'TODOS',
        onClick: () => handleFilterItemClick('MIEM', 'TODOS'),
        count: counts.TODOS,
      },
      {
        label: 'FAM',
        value: 'FAM',
        onClick: () => handleFilterItemClick('MIEM', 'FAM'),
        count: counts.FAM,
      },
      {
        label: 'EA',
        value: 'EA',
        onClick: () => handleFilterItemClick('MIEM', 'EA'),
        count: counts.EA,
      },
      {
        label: 'IS',
        value: 'IS',
        onClick: () => handleFilterItemClick('MIEM', 'IS'),
        count: counts.IS,
      },
      {
        label: 'ISV',
        value: 'ISV',
        onClick: () => handleFilterItemClick('MIEM', 'ISV'),
        count: counts.ISV,
      },
      {
        label: 'LA',
        value: 'LA',
        onClick: () => handleFilterItemClick('MIEM', 'LA'),
        count: counts.LA,
      },
      {
        label: 'MSJ',
        value: 'MSJ',
        onClick: () => handleFilterItemClick('MIEM', 'MSJ'),
        count: counts.MSJ,
      },
      {
        label: 'ZCC',
        value: 'ZCC',
        onClick: () => handleFilterItemClick('MIEM', 'ZCC'),
        count: counts.ZCC,
      },
      {
        label: 'SIN ASIGNAR',
        value: '',
        onClick: () => handleFilterItemClick('MIEM', ''),
        count: counts[''],
      },
    ];
  }, [counts]); // Depend on counts instead of getPrePaginationRowModel

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setGlobalFilter(e.target.value || undefined);
  };

  return (
    <Row className="g-3 justify-content-between align-items-center mb-4">
      <Col xs={12} sm="auto">
{/*         <FilterTab tabItems={tabItems} />
 */}      </Col>
      <Col xs={12} sm="auto">
        <div className="d-flex align-items-center gap-1">
          <SearchBox
            onChange={handleSearchInputChange}
            placeholder="Buscar"
            style={{ maxWidth: '30rem' }}
            className="me-3"
          />
        </div>
      </Col>
    </Row>
  );
};

export default PagosGeneralesTopSection;